export const ZIP_MASSIVE_MODAL_QUERY = 'zip-massive';
